var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef, useCallback, useMemo } from "react";
import "./FileDragAndDrop.css";
import iconImage from "./DragAndDropLine.svg";
import { Button } from "../../index";
import { Typography } from "../../technical-fundamental";
import { useMergeRefs } from "../../../common/useFallbackRef";
var FileDragAndDrop = forwardRef(function (_a, ref) {
    var id = _a.id, name = _a.name, idMessage = _a.idMessage, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c, onChange = _a.onChange, onBlur = _a.onBlur, accept = _a.accept, _d = _a.multiple, multiple = _d === void 0 ? true : _d, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "name", "idMessage", "disabled", "required", "onChange", "onBlur", "accept", "multiple", "className", "style"]);
    var innerRef = React.useRef(null);
    var combinedRef = useMergeRefs([ref, innerRef]);
    var _e = useState(false), dragging = _e[0], setDragging = _e[1];
    var classNameDiv = useMemo(function () {
        var classNameDivTemp = "ssg-file-drag-and-drop ";
        if (dragging) {
            classNameDivTemp += "ssg-file-drag-and-drop--over";
        }
        if (className) {
            classNameDivTemp += " " + className;
        }
        return classNameDivTemp;
    }, [dragging]);
    var handleChange = function (event) {
        if (onChange) {
            onChange(event);
        }
    };
    var handleBlur = function (event) {
        if (onBlur) {
            onBlur(event);
        }
    };
    var handleBoutonClick = useCallback(function () {
        if (innerRef && innerRef.current) {
            innerRef.current.click();
        }
    }, [combinedRef]);
    var handleDragOver = function (event) {
        event.preventDefault();
        setDragging(true);
    };
    var handleDragLeave = function (event) {
        event.preventDefault();
        setDragging(false);
    };
    var handleDrop = function (event) {
        event.preventDefault();
        setDragging(false);
        var files = event.dataTransfer.files;
        onChange === null || onChange === void 0 ? void 0 : onChange({
            target: {
                files: files,
            },
        });
    };
    if (disabled) {
        return null;
    }
    return (React.createElement("div", { className: classNameDiv, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop },
        React.createElement("div", null,
            React.createElement(Typography, { size: "lg", className: "ssg-file-drag-and-drop__text-line" + (dragging ? " fr-mb-0" : "") },
                React.createElement("img", { src: iconImage, alt: "", className: "fr-mr-1w" }),
                dragging ? "Ajouter votre sélection" : "Glisser un ou plusieurs fichiers"),
            !dragging && (React.createElement(Typography, { size: "lg", className: "ssg-file-drag-and-drop__text-line fr-m-0" },
                React.createElement("span", null, "OU"),
                React.createElement(Button, { className: "fr-ml-1w", icon: "fr-icon-search-line", iconPosition: "left", onClick: handleBoutonClick, disabled: disabled }, "Parcourir..."))),
            React.createElement("input", __assign({ ref: combinedRef, type: "file", id: id, name: name, required: required, accept: accept, multiple: multiple, onChange: handleChange, onBlur: handleBlur, style: style, className: "ssg-file-drag-and-drop__input", "aria-describedby": idMessage }, otherProps)))));
});
export default FileDragAndDrop;
